const IconCircuit = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.9999 0.833252C10.2463 0.833252 8.83325 2.26781 8.83325 4.02682C8.83325 5.00167 9.28232 5.71888 9.79719 6.30639C10.0226 6.56359 10.2714 6.80765 10.5049 7.03672L10.5917 7.12205C10.856 7.38199 11.0982 7.62605 11.3053 7.88319C11.6537 8.31605 12.3372 8.33165 12.6995 7.89779C12.9133 7.64172 13.1594 7.39559 13.4253 7.13159L13.4546 7.10252C13.7063 6.85265 13.9754 6.58564 14.2179 6.30185C14.7266 5.70658 15.1666 4.98333 15.1666 4.02682C15.1666 2.26781 13.7535 0.833252 11.9999 0.833252ZM11.9999 2.83325C11.3556 2.83325 10.8333 3.35559 10.8333 3.99992C10.8333 4.64425 11.3556 5.16659 11.9999 5.16659H12.0059C12.6503 5.16659 13.1726 4.64425 13.1726 3.99992C13.1726 3.35559 12.6503 2.83325 12.0059 2.83325H11.9999Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.833252 12.6666C0.833252 11.2859 1.95254 10.1666 3.33325 10.1666C4.71397 10.1666 5.83325 11.2859 5.83325 12.6666C5.83325 14.0473 4.71397 15.1666 3.33325 15.1666C1.95254 15.1666 0.833252 14.0473 0.833252 12.6666Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.33325 6.66659C3.33325 5.10111 4.77651 3.99992 6.33325 3.99992H7.33325C7.70145 3.99992 7.99992 4.2984 7.99992 4.66659C7.99992 5.03477 7.70145 5.33325 7.33325 5.33325H6.33325C5.31266 5.33325 4.66659 6.02292 4.66659 6.66659C4.66659 7.31025 5.31266 7.99992 6.33325 7.99992H8.33325C9.88999 7.99992 11.3333 9.10112 11.3333 10.6666C11.3333 12.2321 9.88999 13.3333 8.33325 13.3333H7.33325C6.96505 13.3333 6.66659 13.0348 6.66659 12.6666C6.66659 12.2984 6.96505 11.9999 7.33325 11.9999H8.33325C9.35385 11.9999 9.99992 11.3103 9.99992 10.6666C9.99992 10.0229 9.35385 9.33325 8.33325 9.33325H6.33325C4.77651 9.33325 3.33325 8.23205 3.33325 6.66659Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconCircuit;
